import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top on every route change so that
 * navigating between pages always presents them from the very top,
 * never preserving the previous scroll position.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // "auto" (not "smooth") so the reset is instantaneous, matching
    // native page-load behaviour.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
